(function () {
  "use strict";

  var SVG_ICONS = {
    battery: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="7" width="16" height="10" rx="2"></rect><path d="M21 10v4"></path><path d="M7 12h4"></path></svg>',
    body: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="5" r="2.2"></circle><path d="M8.5 21l1.2-6.2-2.2-3.1 1.7-3.2h5.6l1.7 3.2-2.2 3.1 1.2 6.2"></path><path d="M9.7 14.8h4.6"></path></svg>',
    brain: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.5 4.4A3 3 0 0 0 5 7a3.1 3.1 0 0 0-1 5.8A3.5 3.5 0 0 0 7.4 18H10V5.7a2.3 2.3 0 0 0-.5-1.3Z"></path><path d="M14.5 4.4A3 3 0 0 1 19 7a3.1 3.1 0 0 1 1 5.8 3.5 3.5 0 0 1-3.4 5.2H14V5.7c0-.5.2-.9.5-1.3Z"></path><path d="M7 9.5c1.3 0 2 .6 3 1.5M17 9.5c-1.3 0-2 .6-3 1.5M7.5 15c1 0 1.8-.4 2.5-1M16.5 15c-1 0-1.8-.4-2.5-1"></path></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"></circle><path d="M12 7.5V12l3.2 2"></path></svg>',
    repeat: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 3l3 3-3 3"></path><path d="M4 10V8a2 2 0 0 1 2-2h14"></path><path d="M7 21l-3-3 3-3"></path><path d="M20 14v2a2 2 0 0 1-2 2H4"></path></svg>',
    sunset: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 18h16"></path><path d="M6 18a6 6 0 0 1 12 0"></path><path d="M12 3v3M4.2 8.2l2.1 2.1M19.8 8.2l-2.1 2.1"></path></svg>',
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 15.5A8 8 0 0 1 8.5 4a8.2 8.2 0 1 0 11.5 11.5Z"></path></svg>',
    coffee: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h12v6a5 5 0 0 1-5 5h-2a5 5 0 0 1-5-5V8Z"></path><path d="M17 10h1.5a2.5 2.5 0 0 1 0 5H17"></path><path d="M8 4v2M12 3v3M16 4v2"></path></svg>',
    sweat: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3s5 6.1 5 10a5 5 0 0 1-10 0c0-3.9 5-10 5-10Z"></path><path d="M9.5 13.5a2.5 2.5 0 0 0 2.5 2.5"></path></svg>',
    bottle: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 3h6v3l2 2.5V20H7V8.5L9 6V3Z"></path><path d="M7 11h10M10 3h4"></path></svg>',
    plate: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"></circle><circle cx="12" cy="12" r="4.5"></circle></svg>',
    pulse: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12h4l2.5-6 4 12 2.5-6h5"></path></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 4 4 10-10"></path></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>',
    back: '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 18l-6-6 6-6"></path></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 11v5M12 8h.01"></path></svg>'
  };

  var QUESTION_META = {
    today: {
      icon: "battery", visual: true,
      weights: [
        { recovery: 2, basis: 2 },
        { recovery: 1, basis: 3 },
        { recovery: 2, caffeine: 1, basis: 1 },
        {}
      ], optionIcons: ["battery", "body", "brain", "clock"]
    },
    missed: {
      icon: "repeat",
      weights: [{}, {}, { recovery: 1, basis: 1 }, { recovery: 1, basis: 1 }]
    },
    timing: {
      icon: "sunset",
      weights: [{ recovery: 3 }, { caffeine: 1.5, basis: 1 }, {}, { basis: 0.5 }]
    },
    wake: {
      icon: "moon",
      weights: [{}, { recovery: 0.5 }, { recovery: 2 }, { recovery: 4 }]
    },
    caffeine: {
      icon: "coffee",
      weights: [{}, { caffeine: 1 }, { caffeine: 3 }, { caffeine: 5 }]
    },
    sweat: {
      icon: "sweat",
      weights: [{}, { basis: 1 }, { basis: 2 }, { basis: 3 }]
    },
    afterSweat: {
      icon: "bottle",
      weights: [{ basis: 2 }, { basis: 0.5 }, {}, { basis: 3 }]
    },
    signals: {
      icon: "pulse", multi: true,
      weights: [{ basis: 1 }, { basis: 1 }, { basis: 1 }, { basis: 1 }, {}]
    },
    nutrition: {
      icon: "plate",
      weights: [{}, { basis: 0.5 }, { basis: 2 }, { basis: 3, recovery: 1 }]
    }
  };

  var QUESTION_ORDER = ["today", "missed", "timing", "wake", "caffeine", "sweat", "afterSweat", "signals", "nutrition"];
  var FLOW = [
    { type: "question", id: "today" },
    { type: "question", id: "missed" },
    { type: "question", id: "timing" },
    { type: "question", id: "wake" },
    { type: "insight", id: "insight" },
    { type: "question", id: "caffeine" },
    { type: "question", id: "sweat" },
    { type: "question", id: "afterSweat" },
    { type: "question", id: "signals" },
    { type: "question", id: "nutrition" },
    { type: "analysis", id: "analysis" },
    { type: "optin", id: "optin" },
    { type: "result", id: "result" }
  ];

  var RESULT_META = {
    basis: { highlights: ["sweat", "afterSweat", "signals"], fit: "strong" },
    caffeine: { highlights: ["caffeine", "timing", "wake"], fit: "strong" },
    recovery: { highlights: ["wake", "timing", "today"], fit: "strong" },
    mixed: { highlights: ["wake", "caffeine", "afterSweat"], fit: "strong" },
    steady: { highlights: ["today", "missed", "wake"], fit: "soft" }
  };

  function parseConfig(root) {
    var node = root.querySelector('[data-vivid-quiz-config]');
    if (!node) throw new Error('VIVID Quiz: Konfiguration fehlt.');
    return JSON.parse(node.textContent);
  }

  function iconHTML(icon, fallback) {
    var url = icon && typeof icon === "object" ? icon.url : icon;
    var fallbackKey = (icon && typeof icon === "object" && icon.fallback) || fallback || "check";
    if (url) return '<img class="custom-icon-image" src="' + url + '" alt="" loading="lazy" decoding="async">';
    return SVG_ICONS[fallbackKey] || SVG_ICONS.check;
  }

  function initialize(root) {
    if (!root || root.dataset.vividQuizInitialized === "true") return;
    root.dataset.vividQuizInitialized = "true";

    document.documentElement.classList.add("vivid-quiz-page-active");
    if (document.body) document.body.classList.add("vivid-quiz-page-active");

    var settings;
    try {
      settings = parseConfig(root);
    } catch (error) {
      console.error(error);
      return;
    }

    var CONFIG = settings.config || {};
    var EMAIL_GATE = settings.emailGate || {};
    var UI = settings.ui || {};
    var ICONS = settings.icons || {};
    var IMAGES = settings.images || {};
    var QUESTION_COPY = settings.questions || {};
    var RESULT_COPY = settings.results || {};

    var app = root.querySelector('[data-quiz-app]');
    var screenRoot = root.querySelector('[data-screen-root]');
    var emailGateRoot = root.querySelector('[data-email-gate-root]');
    var emailGateSkip = root.querySelector('[data-email-gate-skip]');
    var emailGateFormShell = root.querySelector('[data-email-gate-form-shell]');
    var emailGateFormSlot = root.querySelector('[data-email-gate-form-slot]');
    var emailGateFormState = root.querySelector('[data-email-gate-form-state]');
    var emailGateStateText = root.querySelector('[data-email-gate-state-text]');
    var brandRow = root.querySelector('[data-brand-row]');
    var quizTopbar = root.querySelector('[data-quiz-topbar]');
    var backButton = root.querySelector('[data-back-button]');
    var stepLabel = root.querySelector('[data-step-label]');
    var progressFill = root.querySelector('[data-progress-fill]');
    var liveRegion = root.querySelector('[data-live-region]');

    if (!app || !screenRoot || !emailGateRoot || !emailGateSkip || !emailGateFormShell || !emailGateFormSlot || !emailGateFormState || !emailGateStateText || !brandRow || !quizTopbar || !backButton || !stepLabel || !progressFill || !liveRegion) return;

    var QUESTIONS = QUESTION_ORDER.map(function (id) {
      var meta = QUESTION_META[id];
      var copy = QUESTION_COPY[id] || {};
      var labels = Array.isArray(copy.options) ? copy.options : [];
      var descriptions = Array.isArray(copy.optionDescriptions) ? copy.optionDescriptions : [];
      return {
        id: id,
        phase: copy.phase || "",
        kicker: copy.kicker || "",
        title: copy.title || "",
        helper: copy.helper || "",
        evidenceLabel: copy.evidenceLabel || "Antwort",
        visual: !!meta.visual,
        multi: !!meta.multi,
        icon: { url: copy.iconUrl || null, fallback: meta.icon },
        options: meta.weights.map(function (weights, index) {
          return {
            label: labels[index] || "",
            description: descriptions[index] || "",
            weights: weights,
            icon: {
              url: copy.optionIconUrls && copy.optionIconUrls[index] ? copy.optionIconUrls[index] : null,
              fallback: meta.optionIcons ? meta.optionIcons[index] : "check"
            }
          };
        })
      };
    });

    var RESULTS = {};
    Object.keys(RESULT_META).forEach(function (key) {
      var copy = RESULT_COPY[key] || {};
      RESULTS[key] = Object.assign({}, RESULT_META[key], copy);
    });

    var state = {
      index: 0,
      answers: {},
      timers: [],
      observers: [],
      direction: "forward",
      started: false,
      emailGatePassed: false,
      stepStartedAt: Date.now()
    };

    function createElement(tag, className, html) {
      var element = document.createElement(tag);
      if (className) element.className = className;
      if (html !== undefined) element.innerHTML = html;
      return element;
    }

    function escapeAttribute(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    }

    function format(template, values) {
      return String(template || "").replace(/\{(\w+)\}/g, function (_, key) {
        return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : "";
      });
    }

    function uiIcon(name, fallback) {
      return iconHTML({ url: ICONS[name] || null, fallback: fallback || name }, fallback || name);
    }

    function buttonArrow() {
      return '<span class="button-arrow" aria-hidden="true">' + uiIcon("buttonArrow", "arrow") + '</span>';
    }

    function track(eventName, payload) {
      var eventPayload = Object.assign({
        event: eventName,
        quiz_version: CONFIG.quizVersion,
        quiz_section_id: CONFIG.sectionId,
        timestamp: new Date().toISOString()
      }, payload || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventPayload);
      if (typeof window.fbq === "function") {
        if (eventName === "quiz_start") window.fbq("trackCustom", "QuizStart", eventPayload);
        if (eventName === "quiz_complete") window.fbq("trackCustom", "QuizComplete", eventPayload);
        if (eventName === "quiz_cta_click") window.fbq("trackCustom", "QuizCTA", eventPayload);
      }
    }

    function saveState() {
      try { sessionStorage.setItem(CONFIG.storageKey, JSON.stringify({ answers: state.answers })); } catch (error) {}
    }

    function restoreState() {
      try {
        var raw = sessionStorage.getItem(CONFIG.storageKey);
        if (!raw) return;
        var parsed = JSON.parse(raw);
        if (parsed && parsed.answers && typeof parsed.answers === "object") state.answers = parsed.answers;
      } catch (error) { state.answers = {}; }
    }

    function clearTimers() {
      state.timers.forEach(window.clearTimeout);
      state.timers = [];
    }

    function clearObservers() {
      state.observers.forEach(function (observer) {
        if (observer && typeof observer.disconnect === "function") observer.disconnect();
      });
      state.observers = [];
    }

    function currentStep() { return FLOW[state.index]; }
    function questionById(id) { return QUESTIONS.find(function (q) { return q.id === id; }); }
    function questionPosition(id) { return QUESTIONS.findIndex(function (q) { return q.id === id; }); }
    function answerIndex(id) { return state.answers[id]; }

    function answerLabel(id) {
      var question = questionById(id);
      var index = answerIndex(id);
      if (!question) return "–";
      if (Array.isArray(index)) {
        if (!index.length) return "–";
        return index.map(function (i) { return question.options[i] ? question.options[i].label : ""; }).filter(Boolean).join(" · ");
      }
      if (index === undefined || !question.options[index]) return "–";
      return question.options[index].label;
    }

    function hasBodySignal() {
      var picks = answerIndex("signals");
      if (!Array.isArray(picks)) return false;
      var noneIndex = questionById("signals").options.length - 1;
      return picks.some(function (i) { return i !== noneIndex; });
    }

    function announce(text) {
      liveRegion.textContent = "";
      window.requestAnimationFrame(function () { liveRegion.textContent = text; });
    }

    function updateChrome() {
      var step = currentStep();
      var firstQuestion = step.type === "question" && step.id === "today";
      var isResultLike = step.type === "analysis" || step.type === "optin" || step.type === "result";
      brandRow.hidden = !firstQuestion;
      quizTopbar.hidden = firstQuestion;
      if (firstQuestion) return;

      if (step.type === "question") {
        var qIndex = questionPosition(step.id);
        stepLabel.textContent = format(UI.stepLabelFormat || "{current} / {total}", { current: qIndex + 1, total: QUESTIONS.length });
        progressFill.style.width = Math.max(8, ((qIndex + 1) / QUESTIONS.length) * 100) + "%";
        backButton.hidden = false;
      } else if (step.type === "insight") {
        stepLabel.textContent = format(UI.stepLabelFormat || "{current} / {total}", { current: 4, total: QUESTIONS.length });
        progressFill.style.width = ((4 / QUESTIONS.length) * 100) + "%";
        backButton.hidden = false;
      } else if (isResultLike) {
        stepLabel.textContent = format(UI.stepLabelFormat || "{current} / {total}", { current: QUESTIONS.length, total: QUESTIONS.length });
        progressFill.style.width = "100%";
        backButton.hidden = true;
      }
    }

    function focusScreen() {
      var focusContainer = currentStep().type === "optin" ? emailGateRoot : screenRoot;
      var focusTarget = focusContainer.querySelector("[data-screen-focus], [data-email-gate-focus]");
      if (!focusTarget) return;
      focusTarget.setAttribute("tabindex", "-1");
      try { focusTarget.focus({ preventScroll: true }); } catch (error) { focusTarget.focus(); }
    }

    function recordStepExit() {
      var step = currentStep();
      track("quiz_step_time", { step_type: step.type, step_id: step.id, duration_ms: Date.now() - state.stepStartedAt });
    }

    function goTo(index, direction) {
      clearTimers();
      clearObservers();
      if (screenRoot.firstChild || currentStep().type === "optin") recordStepExit();
      state.direction = direction || "forward";
      state.index = Math.max(0, Math.min(index, FLOW.length - 1));
      state.stepStartedAt = Date.now();
      screenRoot.innerHTML = "";

      var enteringOptin = currentStep().type === "optin";
      screenRoot.hidden = enteringOptin;
      emailGateRoot.hidden = !enteringOptin;
      emailGateRoot.setAttribute("aria-hidden", enteringOptin ? "false" : "true");

      updateChrome();
      var top = root.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: Math.max(0, top), behavior: "auto" });
      var step = currentStep();
      if (step.type === "question") renderQuestion(step.id);
      if (step.type === "insight") renderInsight();
      if (step.type === "analysis") renderAnalysis();
      if (step.type === "optin") renderOptin();
      if (step.type === "result") renderResult();
      track("quiz_step_view", { step_type: step.type, step_id: step.id, step_index: state.index });
      window.requestAnimationFrame(focusScreen);
    }

    function next() { goTo(state.index + 1, "forward"); }
    function back() {
      if (state.index <= 0) return;
      var target = state.index - 1;
      if (FLOW[target].type === "insight") target -= 1;
      goTo(target, "back");
    }

    function renderIntroHero() {
      return '<div class="intro-hero intro-hero-v23">' +
        '<div class="eyebrow">' + UI.introEyebrow + '</div>' +
        '<h1 class="intro-title intro-title-v23" data-screen-focus><span class="title-line">' + UI.introTitle1 + '</span><span class="title-line accent">' + UI.introTitle2 + '</span></h1>' +
        '<div class="intro-copy intro-copy-v23">' +
          '<strong>' + UI.introMirror + '</strong>' +
          '<span>' + UI.introExplanation + '</span>' +
        '</div>' +
        '<div class="intro-proofline">' + UI.introProofline + '</div>' +
      '</div>';
    }

    function renderQuestion(id) {
      var question = questionById(id);
      var qIndex = questionPosition(id);
      var isFirst = qIndex === 0;
      var isMulti = !!question.multi;
      var stored = answerIndex(id);
      var selected = isMulti ? (Array.isArray(stored) ? stored.slice() : []) : stored;
      var hasSelection = isMulti ? selected.length > 0 : selected !== undefined;

      var screen = createElement("section", "screen question-screen" + (isFirst ? " first-question" : ""));
      if (state.direction === "back") screen.classList.add("is-back");
      if (isFirst) screen.insertAdjacentHTML("beforeend", renderIntroHero());

      var head = createElement("div", "question-head");
      if (!isFirst) {
        head.insertAdjacentHTML("beforeend", '<div class="question-icon" aria-hidden="true">' + iconHTML(question.icon, QUESTION_META[id].icon) + '</div>');
        head.insertAdjacentHTML("beforeend", '<div class="question-kicker">' + question.kicker + '</div>');
      } else {
        head.insertAdjacentHTML(
          "beforeend",
          '<div class="first-question-meta"><div class="question-kicker">' + question.kicker + '</div><div class="question-choice-hint">' + UI.singleChoiceHint + '</div></div>'
        );
      }
      var title = createElement("h2", "question-title", question.title);
      title.id = "question-title-" + CONFIG.sectionId + "-" + id;
      if (!isFirst) title.setAttribute("data-screen-focus", "");
      head.appendChild(title);
      if (question.helper) head.appendChild(createElement("p", "question-helper", question.helper));
      screen.appendChild(head);

      var options = createElement("div", "options" + (question.visual ? " visual-grid" : ""));
      options.setAttribute("role", isMulti ? "group" : "radiogroup");
      options.setAttribute("aria-labelledby", title.id);

      var action = createElement("div", "sticky-action");
      var continueButton = createElement("button", "primary-button", hasSelection ? UI.continueText + " " + buttonArrow() : UI.selectText);
      var autoAdvanceTimer = null;
      var advancing = false;

      continueButton.type = "button";
      continueButton.disabled = !hasSelection;

      function refreshButtons() {
        Array.prototype.forEach.call(options.children, function (child, childIndex) {
          var isSelected = isMulti ? selected.indexOf(childIndex) !== -1 : selected === childIndex;
          child.classList.toggle("selected", isSelected);
          child.setAttribute("aria-checked", isSelected ? "true" : "false");
        });
        hasSelection = isMulti ? selected.length > 0 : selected !== undefined;
        continueButton.disabled = !hasSelection;
        if (hasSelection) continueButton.innerHTML = UI.continueText + " " + buttonArrow();
        else continueButton.textContent = UI.selectText;
      }

      function submitAnswer() {
        if (advancing || !hasSelection) return;
        advancing = true;

        if (autoAdvanceTimer !== null) {
          window.clearTimeout(autoAdvanceTimer);
          autoAdvanceTimer = null;
        }

        if (!state.started) {
          state.started = true;
          track("quiz_start", { source_page: window.location.pathname });
        }

        track("quiz_answer", {
          question_id: id,
          question_number: qIndex + 1,
          answer_index: isMulti ? selected.slice() : selected,
          answer_label: answerLabel(id)
        });

        next();
      }

      question.options.forEach(function (option, optionIndex) {
        var button;
        if (question.visual) {
          button = createElement(
            "button",
            "option visual-option visual-option-v23",
            '<span class="visual-option-top">' +
              '<span class="visual-option-icon" aria-hidden="true">' + iconHTML(option.icon, "check") + '</span>' +
            '</span>' +
            '<span class="visual-option-copy">' +
              '<strong class="visual-option-label">' + option.label + '</strong>' +
              (option.description ? '<span class="visual-option-description">' + option.description + '</span>' : '') +
            '</span>'
          );
        } else {
          button = createElement("button", "option" + (isMulti ? " multi" : ""), option.label);
        }
        button.type = "button";
        button.setAttribute("role", isMulti ? "checkbox" : "radio");
        var initiallySelected = isMulti ? selected.indexOf(optionIndex) !== -1 : selected === optionIndex;
        button.setAttribute("aria-checked", initiallySelected ? "true" : "false");
        if (initiallySelected) button.classList.add("selected");
        button.addEventListener("click", function () {
          if (isMulti) {
            var noneIndex = question.options.length - 1;
            if (optionIndex === noneIndex) selected = selected.indexOf(noneIndex) !== -1 ? [] : [noneIndex];
            else {
              var position = selected.indexOf(optionIndex);
              if (position !== -1) selected.splice(position, 1); else selected.push(optionIndex);
              var nonePosition = selected.indexOf(noneIndex);
              if (nonePosition !== -1) selected.splice(nonePosition, 1);
            }
            state.answers[id] = selected.slice();
          } else {
            selected = optionIndex;
            state.answers[id] = optionIndex;
          }
          saveState();
          refreshButtons();
          announce(UI.answerSelectedAnnouncement || "Antwort ausgewählt.");
          if (navigator.vibrate) navigator.vibrate(7);

          if (!isMulti) {
            if (autoAdvanceTimer !== null) window.clearTimeout(autoAdvanceTimer);
            autoAdvanceTimer = window.setTimeout(submitAnswer, 420);
            state.timers.push(autoAdvanceTimer);
          }
        });
        options.appendChild(button);
      });

      continueButton.addEventListener("click", function () {
        submitAnswer();
      });

      action.appendChild(continueButton);
      action.appendChild(createElement("p", "action-microcopy", isFirst ? UI.firstMicrocopy : UI.questionMicrocopy));
      screen.appendChild(options);
      screen.appendChild(action);
      screenRoot.appendChild(screen);
    }

    function renderInsight() {
      var missed = answerIndex("missed") || 0;
      var wake = answerIndex("wake") || 0;
      var today = answerIndex("today") || 0;
      var screen = createElement("section", "screen insight-screen");
      if (state.direction === "back") screen.classList.add("is-back");

      var title = UI.insightDefaultTitle;
      var copy = UI.insightDefaultCopy;
      if (today === 3) { title = UI.insightStressTitle; copy = UI.insightStressCopy; }
      else if (missed >= 2 && wake >= 2) { title = UI.insightTiredTitle; copy = UI.insightTiredCopy; }
      else if (missed <= 1) { title = UI.insightLowTitle; copy = UI.insightLowCopy; }

      var card = createElement("div", "insight-card");
      card.innerHTML = '<div class="insight-label">' + UI.insightLabel + '</div>' +
        '<h1 class="insight-title" data-screen-focus>' + title + '</h1>' +
        '<div class="insight-copy">' + copy + '</div>' +
        '<div class="answer-recap"><span class="answer-recap-mark">' + uiIcon("check", "check") + '</span><span><strong>' + UI.insightRecapLabel + '</strong><br>' + answerLabel("today") + '</span></div>';

      var action = createElement("div", "sticky-action");
      var remaining = QUESTIONS.length - 4;
      var button = createElement("button", "primary-button", format(UI.insightButtonFormat || "Noch {count} Fragen", { count: remaining }) + " " + buttonArrow());
      button.type = "button";
      button.addEventListener("click", next);
      action.appendChild(button);
      action.appendChild(createElement("p", "action-microcopy", UI.insightMicrocopy));
      screen.appendChild(card);
      screen.appendChild(action);
      screenRoot.appendChild(screen);
    }

    function rawScores() {
      var scores = { recovery: 0, caffeine: 0, basis: 0 };
      QUESTIONS.forEach(function (question) {
        var selected = answerIndex(question.id);
        if (selected === undefined) return;
        var picks = Array.isArray(selected) ? selected : [selected];
        picks.forEach(function (pickIndex) {
          var weights = (question.options[pickIndex] || {}).weights || {};
          Object.keys(weights).forEach(function (key) { scores[key] += weights[key]; });
        });
      });
      return scores;
    }

    function computeScores() {
      var raw = rawScores();
      return {
        recovery: Math.min(10, (raw.recovery / 10.25) * 10),
        caffeine: Math.min(10, (raw.caffeine / 6.2) * 10),
        basis: Math.min(10, (raw.basis / 13) * 10)
      };
    }

    function resolveResult(scores) {
      var today = answerIndex("today");
      var physical = [
        ["basis", scores.basis],
        ["caffeine", scores.caffeine],
        ["recovery", scores.recovery]
      ].sort(function (a, b) { return b[1] - a[1]; });

      /* Priorität der Ergebnisse:
         1. Mineralmangel
         2. Koffein Abhängigkeit
         3. Erholungsdefizit
         Mehrfachbelastung wird nur ausgegeben, wenn Mineralstoffversorgung
         UND mindestens ein weiterer körperlicher Faktor deutlich auffällig
         sind. So bleibt die Produktempfehlung logisch nachvollziehbar. */
      if (physical[0][1] < 4.4) return "steady";
      if (today === 3 && physical[0][1] < 4.75) return "steady";

      var strongestOther = Math.max(scores.caffeine, scores.recovery);
      var mixedIncludesMinerals =
        scores.basis >= 6.5 &&
        strongestOther >= 6.5 &&
        Math.abs(scores.basis - strongestOther) <= 0.75;

      if (mixedIncludesMinerals) return "mixed";
      return physical[0][0];
    }

    function renderAnalysis() {
      var duration = Math.max(2500, Number(CONFIG.analysisDuration || 4200));
      var screen = createElement("section", "screen analysis-screen");
      var card = createElement("div", "analysis-card analysis-card-v2");

      card.innerHTML =
        '<div class="analysis-v2-label">' + UI.resultLabel + '</div>' +
        '<h1 class="analysis-title analysis-title-v2" data-screen-focus>' + UI.analysisTitle + '</h1>' +
        '<p class="analysis-copy analysis-copy-v2">' + UI.analysisCopy + '</p>' +
        '<div class="analysis-progress-meta"><span data-analysis-status>' + UI.analysisItem1 + '</span><strong data-analysis-value>0%</strong></div>' +
        '<div class="analysis-progress-track" aria-hidden="true"><span class="analysis-progress-fill" data-analysis-progress></span></div>' +
        '<div class="analysis-list analysis-list-v2">' +
          [UI.analysisItem1, UI.analysisItem2, UI.analysisItem3].map(function (text, index) {
            return '<div class="analysis-item analysis-item-v2" data-analysis-item="' + index + '">' +
              '<span class="analysis-step-number">0' + (index + 1) + '</span>' +
              '<span class="analysis-step-copy">' + text + '</span>' +
              '<span class="analysis-check">' + uiIcon("check", "check") + '</span>' +
            '</div>';
          }).join('') +
        '</div>';

      screen.appendChild(card);
      screenRoot.appendChild(screen);

      var progress = screen.querySelector("[data-analysis-progress]");
      var value = screen.querySelector("[data-analysis-value]");
      var status = screen.querySelector("[data-analysis-status]");
      var items = Array.prototype.slice.call(screen.querySelectorAll("[data-analysis-item]"));
      var phases = [
        { at: 0.08, progress: 18, item: 0, text: UI.analysisItem1 },
        { at: 0.36, progress: 48, item: 1, text: UI.analysisItem2 },
        { at: 0.68, progress: 79, item: 2, text: UI.analysisItem3 },
        { at: 0.91, progress: 100, item: 3, text: "Auswertung bereit" }
      ];

      function updateAnalysis(progressValue, activeItem, statusText) {
        progress.style.width = progressValue + "%";
        value.textContent = progressValue + "%";
        status.textContent = statusText;

        items.forEach(function (item, index) {
          item.classList.toggle("on", index < activeItem);
          item.classList.toggle("active", index === activeItem);
        });
      }

      updateAnalysis(0, 0, UI.analysisItem1);

      phases.forEach(function (phase) {
        state.timers.push(window.setTimeout(function () {
          updateAnalysis(phase.progress, phase.item, phase.text);
        }, Math.round(duration * phase.at)));
      });

      state.timers.push(window.setTimeout(next, duration));
    }

    function currentResultData() {
      var scores = computeScores();
      var resultKey = resolveResult(scores);
      return {
        scores: scores,
        resultKey: resultKey,
        result: RESULTS[resultKey] || RESULTS.steady
      };
    }

    function urlProperty(name) {
      try {
        return new URL(window.location.href).searchParams.get(name) || "";
      } catch (error) {
        return "";
      }
    }

    function klaviyoProfileProperties(email, resultData) {
      return {
        email: email,
        "Quiz Source": EMAIL_GATE.quizSource || "60-Sekunden-Check",
        "Quiz Result": resultData.result.name,
        "Quiz Result Key": resultData.resultKey,
        "Quiz Version": CONFIG.quizVersion,
        "Quiz Basis Score": Number(resultData.scores.basis.toFixed(2)),
        "Quiz Caffeine Score": Number(resultData.scores.caffeine.toFixed(2)),
        "Quiz Recovery Score": Number(resultData.scores.recovery.toFixed(2)),
        "Quiz Completed At": new Date().toISOString(),
        "Quiz UTM Source": urlProperty("utm_source"),
        "Quiz UTM Medium": urlProperty("utm_medium"),
        "Quiz UTM Campaign": urlProperty("utm_campaign"),
        "Quiz UTM Content": urlProperty("utm_content")
      };
    }

    function syncQuizProfileToKlaviyo(email, resultData) {
      if (!email) return;

      var properties = klaviyoProfileProperties(email, resultData);
      var eventProperties = {
        "Quiz Source": properties["Quiz Source"],
        "Quiz Result": properties["Quiz Result"],
        "Quiz Result Key": properties["Quiz Result Key"],
        "Quiz Version": properties["Quiz Version"],
        "Basis Score": properties["Quiz Basis Score"],
        "Caffeine Score": properties["Quiz Caffeine Score"],
        "Recovery Score": properties["Quiz Recovery Score"]
      };

      try {
        if (window.klaviyo && typeof window.klaviyo.identify === "function") {
          window.klaviyo.identify(properties);
          if (typeof window.klaviyo.track === "function") {
            window.klaviyo.track("Completed 60-Sekunden-Check", eventProperties);
          }
          return;
        }

        window.klaviyo = window.klaviyo || [];
        if (typeof window.klaviyo.push === "function") {
          window.klaviyo.push(["identify", properties]);
          window.klaviyo.push(["track", "Completed 60-Sekunden-Check", eventProperties]);
        }
      } catch (error) {
        console.warn("VIVID Quiz: Klaviyo-Profileigenschaften konnten nicht ergänzt werden.", error);
      }
    }

    function passEmailGate(method, email) {
      if (state.emailGatePassed) return;
      state.emailGatePassed = true;

      var resultData = currentResultData();

      if (method === "submit") {
        syncQuizProfileToKlaviyo(email, resultData);
      }

      try {
        sessionStorage.setItem(
          CONFIG.storageKey + "_email_gate",
          JSON.stringify({ method: method, completedAt: new Date().toISOString() })
        );
      } catch (error) {}

      track(method === "submit" ? "quiz_email_submit" : "quiz_email_skip", {
        form_id: EMAIL_GATE.formId || "TiPY8N",
        list_name: EMAIL_GATE.listName || "All Subscribers",
        result_type: resultData.resultKey,
        recovery_score: Number(resultData.scores.recovery.toFixed(2)),
        caffeine_score: Number(resultData.scores.caffeine.toFixed(2)),
        basis_score: Number(resultData.scores.basis.toFixed(2))
      });

      if (currentStep().type === "optin") next();
    }

    function klaviyoFormHasRendered(embed) {
      if (!embed) return false;
      return !!(
        embed.querySelector("form") ||
        embed.querySelector("input") ||
        embed.querySelector("button") ||
        embed.children.length > 0
      );
    }

    function normalizeKlaviyoSubmitButton(embed) {
      if (!embed) return;
      var buttons = Array.prototype.slice.call(
        embed.querySelectorAll('button, input[type="submit"]')
      );

      buttons.forEach(function (button) {
        var type = String(button.getAttribute("type") || "").toLowerCase();
        var text = String(button.textContent || button.value || "").trim().toLowerCase();

        var looksLikeSubmit =
          type === "submit" ||
          text.indexOf("ergebnis") !== -1 ||
          text.indexOf("anzeigen") !== -1 ||
          text.indexOf("submit") !== -1 ||
          text.indexOf("anmelden") !== -1;

        if (!looksLikeSubmit) return;

        if (button.tagName === "INPUT") {
          button.value = "ERGEBNIS + GESCHENK SICHERN";
        } else {
          button.textContent = "ERGEBNIS + GESCHENK SICHERN";
        }
      });
    }

    function setEmailGateFormState(mode, text) {
      emailGateFormShell.classList.remove("is-loading", "is-loaded", "is-error");
      emailGateFormShell.classList.add("is-" + mode);
      emailGateFormState.hidden = mode === "loaded";
      if (text) emailGateStateText.textContent = text;
    }

    function mountKlaviyoEmbed() {
      var formId = String(EMAIL_GATE.formId || "TiPY8N").trim();
      emailGateFormSlot.innerHTML = "";
      setEmailGateFormState("loading", "Formular wird geladen …");

      var embed = document.createElement("div");
      embed.className = "klaviyo-form-" + formId;
      embed.setAttribute("data-vivid-klaviyo-embed", formId);
      emailGateFormSlot.appendChild(embed);

      var observer = new MutationObserver(function () {
        if (!klaviyoFormHasRendered(embed)) return;
        normalizeKlaviyoSubmitButton(embed);
        setEmailGateFormState("loaded", "");
        observer.disconnect();
      });
      observer.observe(embed, { childList: true, subtree: true });
      state.observers.push(observer);

      state.timers.push(window.setTimeout(function () {
        if (klaviyoFormHasRendered(embed)) {
          normalizeKlaviyoSubmitButton(embed);
          setEmailGateFormState("loaded", "");
          return;
        }

        setEmailGateFormState(
          "error",
          "Das Formular konnte nicht geladen werden. Prüfe die Klaviyo-App-Einbettung oder lade die Seite neu."
        );
      }, 5000));
    }

    function renderOptin() {
      announce("Deine Auswertung ist bereit.");
      mountKlaviyoEmbed();

      track("quiz_email_gate_view", {
        form_id: EMAIL_GATE.formId || "TiPY8N",
        list_name: EMAIL_GATE.listName || "All Subscribers"
      });
    }

    function onKlaviyoFormEvent(event) {
      var detail = event && event.detail ? event.detail : {};
      if (detail.type !== "submit") return;
      if (String(detail.formId || "") !== String(EMAIL_GATE.formId || "TiPY8N")) return;

      var metadata = detail.metaData || {};
      passEmailGate("submit", metadata.email || "");
    }

    function destinationUrl(resultKey) {
      var target;
      try { target = new URL(CONFIG.landingUrl || "https://nextgen-supplements.com/"); }
      catch (error) { target = new URL("https://nextgen-supplements.com/"); }
      var currentParams = new URLSearchParams(window.location.search);
      ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid", "ttclid", "tw_source", "tw_adid"].forEach(function (key) {
        if (currentParams.has(key)) target.searchParams.set(key, currentParams.get(key));
      });
      target.searchParams.set("ergebnis", resultKey);
      target.searchParams.set("quiz", CONFIG.quizVersion);
      return target.toString();
    }

    function evidenceMeta(id) {
      var question = questionById(id);
      return { id: id, label: question ? question.evidenceLabel : UI.evidenceFallbackLabel, value: answerLabel(id), icon: question ? question.icon : { fallback: "check" } };
    }

    function resolveHighlights(result, resultKey, scores) {
      if (resultKey === "mixed") {
        var factors = [
          { key: "recovery", score: scores.recovery, question: "wake" },
          { key: "caffeine", score: scores.caffeine, question: "caffeine" },
          { key: "basis", score: scores.basis, question: "afterSweat" }
        ].sort(function (a, b) { return b.score - a.score; });

        var highlights = factors
          .filter(function (factor) { return factor.score >= 4.3; })
          .map(function (factor) { return factor.question; });

        ["today", "nutrition", "timing"].forEach(function (id) {
          if (highlights.length < 3 && highlights.indexOf(id) === -1) highlights.push(id);
        });

        return highlights.slice(0, 3);
      }

      var highlights = result.highlights.slice();
      var signalsPosition = highlights.indexOf("signals");
      if (signalsPosition !== -1 && !hasBodySignal()) highlights[signalsPosition] = "nutrition";
      return highlights;
    }

    function mixedProblemText(scores) {
      var factors = [
        { score: scores.recovery, label: "Müdigkeit am Morgen" },
        { score: scores.caffeine, label: "Koffein gegen Müdigkeit" },
        { score: scores.basis, label: "fehlender Ausgleich nach dem Training" }
      ].sort(function (a, b) { return b.score - a.score; })
       .filter(function (factor) { return factor.score >= 4.3; })
       .slice(0, 3)
       .map(function (factor) { return factor.label; });

      if (factors.length === 0) return "Mehrere körperliche Faktoren kommen zusammen.";
      if (factors.length === 1) return factors[0] + " fällt besonders auf.";
      if (factors.length === 2) return factors[0] + " und " + factors[1] + " kommen zusammen.";
      return factors[0] + ", " + factors[1] + " und " + factors[2] + " kommen zusammen.";
    }


    function escapeHTML(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function scorePercent(value) {
      return Math.max(0, Math.min(100, Math.round(Number(value || 0) * 10)));
    }

    function educationShell(resultKey, result, visualHTML) {
      var section = createElement("section", "result-education education-" + resultKey);
      section.setAttribute("data-result-education", resultKey);
      section.innerHTML =
        '<div class="education-head">' +
          '<div class="card-label education-label">' + escapeHTML(UI.educationLabel || "Was wahrscheinlich bei dir passiert") + '</div>' +
          '<h2 class="education-title">' + escapeHTML(result.educationTitle || "Das zeigt dein Muster") + '</h2>' +
          '<p class="education-copy">' + escapeHTML(result.educationCopy || "Deine Antworten deuten auf ein wiederkehrendes Muster hin.") + '</p>' +
        '</div>' +
        '<div class="education-visual" aria-hidden="true">' + visualHTML + '</div>' +
        (result.educationNote ? '<p class="education-note"><span>' + uiIcon("info", "info") + '</span>' + escapeHTML(result.educationNote) + '</p>' : '');
      return section;
    }

    function basisEducation(result) {
      var target = Number(result.educationStatValue || 41);
      var statUrl = String(result.educationStatUrl || "").trim();
      var source = escapeHTML(result.educationStatSource || "");
      var sourceHTML = source;
      if (statUrl && source) {
        sourceHTML = '<a href="' + escapeAttribute(statUrl) + '" target="_blank" rel="noopener noreferrer">' + source + '</a>';
      }

      var visual =
        '<div class="education-flow education-flow-minerals">' +
          '<div class="education-flow-node" style="--education-delay:0ms"><span class="education-flow-icon education-icon-training"><i></i></span><small>01</small><strong>Training</strong><em>Belastung steigt</em></div>' +
          '<span class="education-flow-arrow" style="--education-delay:180ms">→</span>' +
          '<div class="education-flow-node" style="--education-delay:360ms"><span class="education-flow-icon education-icon-sweat"><i></i></span><small>02</small><strong>Schwitzen</strong><em>Wasser + Mineralstoffe</em></div>' +
          '<span class="education-flow-arrow" style="--education-delay:540ms">→</span>' +
          '<div class="education-flow-node" style="--education-delay:720ms"><span class="education-flow-icon education-icon-refill"><i>H₂O</i></span><small>03</small><strong>Nur trinken</strong><em>Ausgleich bleibt offen</em></div>' +
          '<span class="education-flow-arrow" style="--education-delay:900ms">→</span>' +
          '<div class="education-flow-node education-flow-node-alert" style="--education-delay:1080ms"><span class="education-flow-icon education-icon-low"><i></i></span><small>04</small><strong>Speicher leerer</strong><em>Du fühlst dich schlapp</em></div>' +
        '</div>' +
        '<div class="education-stat-card">' +
          '<div class="education-stat-number" data-education-counter data-target="' + escapeAttribute(target) + '">0%</div>' +
          '<div class="education-stat-body"><strong>' + escapeHTML(result.educationStatText || "der Männer in Deutschland erreichen die empfohlene Magnesiumzufuhr nicht.") + '</strong>' +
          (sourceHTML ? '<small>' + sourceHTML + '</small>' : '') + '</div>' +
        '</div>';

      return educationShell("basis", result, visual);
    }

    function caffeineEducation(result) {
      var token = String(CONFIG.sectionId || "quiz").replace(/[^a-zA-Z0-9_-]/g, "-");
      var lineGradient = "education-caffeine-line-" + token;
      var fillGradient = "education-caffeine-fill-" + token;
      var visual =
        '<div class="education-chart-meta"><span>WAHRGENOMMENE ENERGIE</span><strong>6 STUNDEN</strong></div>' +
        '<div class="education-caffeine-chart">' +
          '<svg viewBox="0 0 360 232" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Vereinfachter Energieverlauf nach Koffeinkonsum">' +
            '<defs>' +
              '<linearGradient id="' + lineGradient + '" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#ffffff"/><stop offset="32%" stop-color="#ffffff"/><stop offset="46%" stop-color="#ffb347"/><stop offset="66%" stop-color="#ff765c"/><stop offset="100%" stop-color="#e85555"/></linearGradient>' +
              '<linearGradient id="' + fillGradient + '" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#e85555" stop-opacity="0"/><stop offset="100%" stop-color="#e85555" stop-opacity=".78"/></linearGradient>' +
            '</defs>' +
            '<g class="education-chart-grid"><line x1="42" y1="42" x2="348" y2="42"/><line x1="42" y1="82" x2="348" y2="82"/><line x1="42" y1="158" x2="348" y2="158"/></g>' +
            '<g class="education-chart-axes"><line x1="42" y1="22" x2="42" y2="186"/><line x1="42" y1="186" x2="348" y2="186"/><text x="36" y="45" text-anchor="end">HIGH</text><text x="36" y="123" text-anchor="end">BASE</text><text x="36" y="178" text-anchor="end">LOW</text><text x="42" y="218" text-anchor="middle">0h</text><text x="144" y="218" text-anchor="middle">2h</text><text x="246" y="218" text-anchor="middle">4h</text><text x="348" y="218" text-anchor="middle">6h</text></g>' +
            '<g class="education-chart-baseline"><line x1="42" y1="120" x2="348" y2="120"/><rect x="272" y="111" width="70" height="18"/><text x="278" y="124">BASELINE</text></g>' +
            '<path class="education-chart-crash-fill" d="M228 120 C234 145 248 169 264 174 C284 174 306 160 326 146 L348 138 L348 120 Z" fill="url(#' + fillGradient + ')"/>' +
            '<path class="education-chart-line" d="M42 122 C72 120 92 115 112 104 C132 89 147 62 160 36 C176 49 191 78 211 113 C230 147 249 169 264 174 C284 174 306 160 326 146 L348 138" fill="none" stroke="url(#' + lineGradient + ')" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<g class="education-chart-peak"><line x1="160" y1="36" x2="160" y2="120"/><circle cx="160" cy="36" r="5"/><text x="160" y="17" text-anchor="middle">KOFFEIN-PEAK</text></g>' +
            '<g class="education-chart-crash"><line x1="264" y1="174" x2="264" y2="196"/><circle cx="264" cy="174" r="5"/><text x="264" y="209" text-anchor="middle">ADENOSIN-REBOUND</text></g>' +
          '</svg>' +
          '<div class="education-chart-callout"><span>Der Kick ist kurz.</span><strong>Die Müdigkeit wurde nicht gelöst – nur verschoben.</strong></div>' +
        '</div>';
      return educationShell("caffeine", result, visual);
    }

    function recoveryEducation(result) {
      var visual =
        '<div class="education-recovery-hero">' +
          '<div class="education-battery-wrap">' +
            '<div class="education-battery"><span class="education-battery-fill"></span><i></i></div>' +
            '<strong class="education-battery-value">55%</strong>' +
            '<small>STARTENERGIE</small>' +
          '</div>' +
          '<div class="education-recovery-message"><span>Du startest nicht bei 100 %.</span><strong>Das Training beginnt mit dem Rest des Tages im Akku.</strong></div>' +
        '</div>' +
        '<div class="education-recovery-track">' +
          '<div class="education-level-row" style="--education-level:55%;--education-delay:220ms"><span>Aufwachen</span><i><b></b></i><strong>55%</strong></div>' +
          '<div class="education-level-row" style="--education-level:31%;--education-delay:520ms"><span>Nachmittag</span><i><b></b></i><strong>31%</strong></div>' +
          '<div class="education-level-row education-level-danger" style="--education-level:14%;--education-delay:820ms"><span>Training</span><i><b></b></i><strong>14%</strong></div>' +
        '</div>';
      return educationShell("recovery", result, visual);
    }

    function mixedEducation(result, scores) {
      var factors = [
        { label: "Erholung", detail: "Müdigkeit am Morgen", value: scorePercent(scores.recovery) },
        { label: "Koffein", detail: "Kick gegen Müdigkeit", value: scorePercent(scores.caffeine) },
        { label: "Ausgleich", detail: "nach Training & Schwitzen", value: scorePercent(scores.basis) }
      ].sort(function (a, b) { return b.value - a.value; });

      var rows = factors.map(function (factor, index) {
        return '<div class="education-factor-row" style="--education-score:' + factor.value + '%;--education-delay:' + (220 + index * 250) + 'ms">' +
          '<div><strong>' + factor.label + '</strong><small>' + factor.detail + '</small></div>' +
          '<span><i></i></span><b>' + factor.value + '%</b>' +
        '</div>';
      }).join("");

      var visual =
        '<div class="education-factor-list">' + rows + '</div>' +
        '<div class="education-priority-card"><span>DEIN STARTPUNKT</span><strong>Nicht alles gleichzeitig ändern.</strong><p>Beginne mit dem Hebel, den du jeden Morgen am einfachsten konstant halten kannst.</p></div>';
      return educationShell("mixed", result, visual);
    }

    function steadyEducation(result) {
      var days = ["MO", "DI", "MI", "DO", "FR", "SA", "SO"].map(function (day, index) {
        return '<div class="education-day' + (index === 0 ? ' is-today' : '') + '" style="--education-delay:' + (180 + index * 110) + 'ms"><span>' + day + '</span><i></i></div>';
      }).join("");
      var visual =
        '<div class="education-week">' + days + '</div>' +
        '<div class="education-steady-line"><span class="education-steady-dot"></span><i></i><strong>Ein einzelner schlechter Tag</strong></div>' +
        '<div class="education-steady-line education-steady-line-pattern"><span class="education-steady-dot"></span><i></i><strong>Ein Muster über mehrere Tage</strong></div>' +
        '<div class="education-observe-card"><span>7-TAGE-CHECK</span><strong>Beobachte Schlaf, Koffein, Essen und Trainingsenergie.</strong></div>';
      return educationShell("steady", result, visual);
    }

    function renderEducation(resultKey, result, scores) {
      if (resultKey === "basis") return basisEducation(result);
      if (resultKey === "caffeine") return caffeineEducation(result);
      if (resultKey === "recovery") return recoveryEducation(result);
      if (resultKey === "mixed") return mixedEducation(result, scores);
      return steadyEducation(result);
    }

    function runEducationCounter(section) {
      var counter = section && section.querySelector("[data-education-counter]");
      if (!counter || counter.dataset.hasRun === "true") return;
      counter.dataset.hasRun = "true";
      var target = Number(counter.getAttribute("data-target") || 0);
      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduceMotion) {
        counter.textContent = Math.round(target) + "%";
        return;
      }
      var startTime = null;
      var duration = 1500;
      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        counter.textContent = Math.round(target * eased) + "%";
        if (progress < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }

    function activateEducation(section, resultKey) {
      if (!section) return;
      var activate = function () {
        if (section.dataset.educationActive === "true") return;
        section.dataset.educationActive = "true";
        section.classList.add("is-visible");
        runEducationCounter(section);
        track("quiz_education_view", { result_type: resultKey });
      };

      if (!("IntersectionObserver" in window)) {
        activate();
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activate();
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.28, rootMargin: "0px 0px -40px 0px" });
      observer.observe(section);
      state.observers.push(observer);
    }

    function renderResult() {
      var scores = computeScores();
      var resultKey = resolveResult(scores);
      var result = RESULTS[resultKey] || RESULTS.steady;
      var screen = createElement("section", "screen result-screen visual-result");

      var hero = createElement("div", "result-hero");
      hero.innerHTML = '<div class="result-meta"><span class="result-label">' + UI.resultLabel + '</span><span class="result-source">' + UI.resultSource + '</span></div>' +
        '<h1 class="result-name" data-screen-focus>' + result.name + '</h1>' +
        '<div class="result-headline">' + result.headline + '</div>';
      screen.appendChild(hero);

      var evidence = createElement("section", "visual-section");
      evidence.innerHTML = '<div class="visual-section-head"><div><div class="card-label">' + UI.evidenceLabel + '</div><h2 class="visual-section-title">' + UI.evidenceTitle + '</h2></div></div>';
      var grid = createElement("div", "evidence-grid");
      resolveHighlights(result, resultKey, scores).map(evidenceMeta).forEach(function (item) {
        grid.insertAdjacentHTML("beforeend", '<div class="evidence-tile"><span class="evidence-icon">' + iconHTML(item.icon, "check") + '</span><span class="evidence-key">' + item.label + '</span><span class="evidence-value">' + item.value + '</span></div>');
      });
      evidence.appendChild(grid);
      evidence.insertAdjacentHTML("beforeend", '<div class="result-conclusion"><span class="result-conclusion-icon">' + uiIcon("patternArrow", "arrow") + '</span><span class="result-conclusion-copy"><small>' + UI.conclusionLabel + '</small><strong>' + result.proofConclusion + '</strong></span></div>');
      screen.appendChild(evidence);

      var education = renderEducation(resultKey, result, scores);
      screen.appendChild(education);

      var founder = createElement("section", "visual-founder");
      founder.innerHTML = '<div class="visual-founder-media"><img class="visual-founder-image" src="' + escapeAttribute(IMAGES.founder) + '" alt="' + escapeAttribute(IMAGES.founderAlt) + '" loading="lazy" decoding="async"><span class="visual-founder-badge">' + UI.founderLabel + '</span></div>' +
        '<div class="visual-founder-content"><h2 class="visual-founder-title">' + result.founderTitle + '</h2><p class="visual-founder-copy">' + result.founderCopy + '</p><p class="visual-founder-origin">' + UI.founderOriginPrefix + ' <span>' + UI.founderOriginProduct + '</span></p></div>';
      screen.appendChild(founder);

      var fitProblem = resultKey === "mixed" ? mixedProblemText(scores) : result.fitProblem;
      var product = createElement("section", "visual-product" + (result.fit === "soft" ? " soft-fit" : ""));
      product.setAttribute("data-result-product", "");
      product.innerHTML =
        '<div class="fit-bridge">' +
          '<div class="card-label">' + UI.relevanceLabel + '</div>' +
          '<div class="fit-flow">' +
            '<div class="fit-flow-row fit-flow-problem"><span class="fit-flow-label">' + UI.fitProblemLabel + '</span><strong>' + fitProblem + '</strong></div>' +
            '<div class="fit-flow-arrow">' + uiIcon("patternArrow", "arrow") + '</div>' +
            '<div class="fit-flow-row fit-flow-solution"><span class="fit-flow-label">' + UI.fitSolutionLabel + '</span><strong>' + result.fitSolution + '</strong></div>' +
          '</div>' +
        '</div>' +
        '<div class="visual-product-hero"><div><div class="visual-product-kicker">' + UI.productKicker + '</div><h2 class="visual-product-title">' + result.productPromise + '</h2></div>' +
        '<img class="visual-product-image" src="' + escapeAttribute(IMAGES.product) + '" alt="' + escapeAttribute(IMAGES.productAlt) + '" loading="lazy" decoding="async"></div>' +
        '<div class="fact-chips"><div class="fact-chip"><strong>' + UI.fact1Value + '</strong><span>' + UI.fact1Label + '</span></div><div class="fact-chip"><strong>' + UI.fact2Value + '</strong><span>' + UI.fact2Label + '</span></div><div class="fact-chip"><strong>' + UI.fact3Value + '</strong><span>' + UI.fact3Label + '</span></div></div>';

      if (UI.productNote) {
        product.insertAdjacentHTML("beforeend", '<div class="product-role-note"><span class="product-role-icon">' + uiIcon("info", "info") + '</span><span>' + UI.productNote + '</span></div>');
      }

      var action = createElement("div", "visual-product-action");
      var cta = createElement("a", "primary-button", result.cta + " " + buttonArrow());
      cta.setAttribute("data-result-main-cta", "");
      cta.href = destinationUrl(resultKey);
      cta.addEventListener("click", function () {
        track("quiz_cta_click", { placement: "main", result_type: resultKey, recovery_score: Number(scores.recovery.toFixed(2)), caffeine_score: Number(scores.caffeine.toFixed(2)), basis_score: Number(scores.basis.toFixed(2)) });
      });
      action.appendChild(cta);
      action.appendChild(createElement("p", "product-microcopy", UI.productMicrocopy));
      if (UI.productTrustLine) action.appendChild(createElement("p", "product-trust-line", UI.productTrustLine));
      product.appendChild(action);
      screen.appendChild(product);


      var stickyCta = null;
      if (UI.showStickyCta && result.fit !== "soft") {
        stickyCta = createElement("aside", "result-sticky-cta");
        stickyCta.hidden = true;
        var stickyLink = createElement("a", "result-sticky-link", '<span>' + result.cta + '</span>' + buttonArrow());
        stickyLink.href = destinationUrl(resultKey);
        stickyLink.addEventListener("click", function () {
          track("quiz_cta_click", { placement: "sticky", result_type: resultKey, recovery_score: Number(scores.recovery.toFixed(2)), caffeine_score: Number(scores.caffeine.toFixed(2)), basis_score: Number(scores.basis.toFixed(2)) });
        });
        stickyCta.appendChild(stickyLink);
        screen.appendChild(stickyCta);
      }

      var legal = createElement("details", "legal-details");
      legal.innerHTML = '<summary>' + UI.legalSummary + '</summary><div class="legal-details-content">' +
        (UI.claimText ? '<p class="legal-copy">' + UI.claimText + '</p>' : '') +
        '<p class="legal-copy">' + UI.legalCopy1 + '</p><p class="legal-copy">' + UI.legalCopy2 + '</p></div>';
      screen.appendChild(legal);

      var restart = createElement("button", "restart-button", UI.restartText);
      restart.type = "button";
      restart.addEventListener("click", function () {
        track("quiz_restart", { previous_result: resultKey });
        state.answers = {};
        state.started = false;
        try { sessionStorage.removeItem(CONFIG.storageKey); } catch (error) {}
        goTo(0, "back");
      });
      screen.appendChild(restart);
      screenRoot.appendChild(screen);
      activateEducation(education, resultKey);

      if (stickyCta && "IntersectionObserver" in window) {
        var productSeen = false;
        var mainCtaVisible = false;
        var updateSticky = function () {
          var shouldShow = productSeen && !mainCtaVisible;
          stickyCta.hidden = !shouldShow;
          screen.classList.toggle("has-result-sticky", shouldShow);
        };
        var productObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) productSeen = true;
          });
          updateSticky();
        }, { threshold: 0.2 });
        var ctaObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            mainCtaVisible = entry.isIntersecting;
          });
          updateSticky();
        }, { threshold: 0.55 });
        productObserver.observe(product);
        ctaObserver.observe(cta);
        state.observers.push(productObserver, ctaObserver);
      }

      track("quiz_complete", { result_type: resultKey, recovery_score: Number(scores.recovery.toFixed(2)), caffeine_score: Number(scores.caffeine.toFixed(2)), basis_score: Number(scores.basis.toFixed(2)) });
    }

    function onKeydown(event) {
      var step = currentStep();
      if (step.type !== "question") return;
      if (/^[1-5]$/.test(event.key)) {
        var option = screenRoot.querySelectorAll(".option")[Number(event.key) - 1];
        if (option) option.click();
      }
      if (event.key === "Enter") {
        var enabledButton = screenRoot.querySelector(".sticky-action .primary-button:not(:disabled)");
        if (enabledButton) enabledButton.click();
      }
    }

    emailGateSkip.addEventListener("click", function () {
      passEmailGate("skip", "");
    });
    window.addEventListener("klaviyoForms", onKlaviyoFormEvent);

    backButton.innerHTML = uiIcon("back", "back") + '<span>' + UI.backText + '</span>';
    backButton.addEventListener("click", back);
    root.addEventListener("keydown", onKeydown);

    restoreState();
    track("quiz_landing_view", { source_page: window.location.pathname, has_saved_answers: Object.keys(state.answers).length > 0 });
    goTo(0, "forward");

    root.__vividQuizCleanup = function () {
      clearTimers();
      clearObservers();
      root.removeEventListener("keydown", onKeydown);
      window.removeEventListener("klaviyoForms", onKlaviyoFormEvent);
      root.dataset.vividQuizInitialized = "false";
    };
    root.__NEXTGEN_QUIZ__ = { computeScores: computeScores, resolveResult: resolveResult, state: state, questions: QUESTIONS, goTo: goTo };
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-vivid-quiz]').forEach(initialize);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initializeAll(document); });
  else initializeAll(document);

  document.addEventListener("shopify:section:load", function (event) { initializeAll(event.target); });
  document.addEventListener("shopify:section:unload", function (event) {
    var root = event.target.querySelector ? event.target.querySelector('[data-vivid-quiz]') : null;
    if (root && typeof root.__vividQuizCleanup === "function") root.__vividQuizCleanup();
  });
})();